import { saveAs } from "file-saver";

export async function downloadLotterySalesXLSX(report, range) {
  const ExcelJS = (await import("exceljs")).default;

  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet("Борлуулалтын тайлан");

  const border = { style: "thin", color: { argb: "FFBFBFBF" } };
  const setBorder = (c) =>
    (c.border = { top: border, left: border, bottom: border, right: border });

  const center = { horizontal: "center", vertical: "middle" };
  const leftMid = { horizontal: "left", vertical: "middle" };
  const money = "#,##0.00;[Red]-#,##0.00";

  // ========= 1) Title + Range =========
  const fromText = Array.isArray(range) ? range?.[0] : "";
  const toText = Array.isArray(range) ? range?.[1] : "";

  ws.mergeCells("A1:I1");
  ws.getCell("A1").value =
    fromText && toText ? `Хугацаа: ${fromText} → ${toText}` : "";
  ws.getCell("A1").alignment = center;
  ws.getCell("A1").font = { italic: true, size: 11 };

  ws.addRow([]);

  // ========= 2) Header (MERGE) =========
  // Row index: after title rows + blank row => header starts at 4
  const headerRow1 = 3;
  const headerRow2 = 4;

  // A: №
  ws.mergeCells(`A${headerRow1}:A${headerRow2}`);
  ws.getCell(`A${headerRow1}`).value = "№";
  styleHeader(ws.getCell(`A${headerRow1}`), "FFD9D9D9");

  // B-E: Сугалаа
  ws.mergeCells(`B${headerRow1}:E${headerRow1}`);
  ws.getCell(`B${headerRow1}`).value = "Сугалаа";
  ws.getCell(`B${headerRow1}`).alignment = center;
  ws.getCell(`B${headerRow1}`).font = { bold: true };
  ws.getCell(`B${headerRow1}`).fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFE0E0E0" },
  };
  ws.getCell(`B${headerRow1}`).border = {
    right: { style: "thin", color: { argb: "FF808080" } },
    top: border,
    left: border,
    bottom: border,
  };

  ws.getCell(`B${headerRow2}`).value = "Prefix";
  ws.getCell(`C${headerRow2}`).value = "Нэр";
  ws.getCell(`D${headerRow2}`).value = "Төлөв";
  ws.getCell(`E${headerRow2}`).value = "Үнэ";
  //   [ws.getCell(`B${headerRow2}`), ws.getCell(`E${headerRow2}`)].forEach((c) =>
  //     styleHeader(c, "FFD9D9D9"),
  //   );
  ["B", "C", "D", "E"].forEach((col) =>
    styleHeader(ws.getCell(`${col}${headerRow2}`), "FFD9D9D9"),
  );

  // F-I: Борлуулалт
  ws.mergeCells(`F${headerRow1}:J${headerRow1}`);
  ws.getCell(`F${headerRow1}`).value = "Борлуулалт";
  ws.getCell(`F${headerRow1}`).alignment = center;
  ws.getCell(`F${headerRow1}`).font = { bold: true };
  ws.getCell(`F${headerRow1}`).fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFE0E0E0" },
  };
  ws.getCell(`F${headerRow1}`).border = {
    right: { style: "thin", color: { argb: "FF808080" } },
    top: border,
    left: border,
    bottom: border,
  };

  ws.getCell(`F${headerRow2}`).value = "Нийт дугаар";
  ws.getCell(`G${headerRow2}`).value = "Нийт тасалбар";
  ws.getCell(`H${headerRow2}`).value = "Нийт дүн";
  ws.getCell(`I${headerRow2}`).value = "Эхэлсэн";
  ws.getCell(`J${headerRow2}`).value = "Сүүлд";
  ["F", "G", "H", "I", "J"].forEach((col) =>
    styleHeader(ws.getCell(`${col}${headerRow2}`), "FFD9D9D9"),
  );

  // Header borders for merged top cells
  ["A", "B", "C", "D", "E", "F", "G", "H", "I"].forEach((col) => {
    setBorder(ws.getCell(`${col}${headerRow1}`));
    setBorder(ws.getCell(`${col}${headerRow2}`));
  });

  // ========= 3) Data =========
  const rows = Array.isArray(report?.rows)
    ? report.rows
    : Array.isArray(report)
      ? report
      : [];

  let totalSoldNumber = 0;
  let totalSoldQty = 0;
  let totalSoldAmount = 0;

  for (let i = 0; i < rows.length; i++) {
    const r = rows[i];

    const soldQty = toNum(r?.sold_ticket_qty) || 0;
    const soldAmount = toNum(r?.sold_total_amount) || 0;

    totalSoldNumber += Number(r?.sold_number_qty ?? 0);
    totalSoldQty += soldQty;
    totalSoldAmount += soldAmount;

    const row = ws.addRow([
      i + 1, // A
      r?.lottery_code || "", // B
      r?.lottery_title || "", // C
      mapStatus(r?.lottery_status), // D
      toNum(r?.ticket_price), // E
      r?.sold_number_qty ?? 0, // F
      soldQty, // G
      soldAmount, // H
      formatDateOnly(r?.first_paid_at), // I
      formatDateOnly(r?.last_paid_at), // J
    ]);

    row.height = 18;

    row.getCell(1).alignment = center;
    row.getCell(2).alignment = center;
    row.getCell(3).alignment = leftMid;
    row.getCell(4).alignment = center;
    row.getCell(5).alignment = center;
    row.getCell(6).alignment = center;
    row.getCell(7).alignment = center;
    row.getCell(8).alignment = center;
    row.getCell(9).alignment = center;

    row.getCell(5).numFmt = money;
    row.getCell(8).numFmt = money;

    row.eachCell((c) => setBorder(c));
  }

  // ========= 4) Footer (Нийт) =========
  const footer = ws.addRow([
    "",
    "Нийт",
    "",
    "",
    "",
    totalSoldNumber,
    totalSoldQty,
    totalSoldAmount,
    "",
    "",
  ]);

  // "ш" suffix numFmt-ээр харуулна
  footer.getCell(6).numFmt = '##,##0"ш"';
  footer.getCell(7).numFmt = '##,##0"ш"';

  ws.mergeCells(`B${footer.number}:E${footer.number}`); // B..E merge

  footer.height = 20;
  footer.getCell(2).alignment = leftMid;
  footer.getCell(2).font = { bold: true };

  footer.getCell(6).alignment = center;
  footer.getCell(6).font = { bold: true };

  footer.getCell(7).alignment = center;
  footer.getCell(7).font = { bold: true };

  footer.getCell(8).alignment = center;
  footer.getCell(8).font = { bold: true };
  footer.getCell(8).numFmt = money;

  footer.eachCell((c) => setBorder(c));

  // ========= 5) Column widths =========
  ws.getColumn("A").width = 6;
  ws.getColumn("B").width = 12;
  ws.getColumn("C").width = 28;
  ws.getColumn("D").width = 14;
  ws.getColumn("E").width = 14;
  ws.getColumn("F").width = 14;
  ws.getColumn("G").width = 14;
  ws.getColumn("H").width = 16;
  ws.getColumn("I").width = 14;
  ws.getColumn("J").width = 14;

  // ========= 6) Download =========
  const buf = await wb.xlsx.writeBuffer();
  const ts = timestamp();
  const filename = `LOTTERY-SALES-${ts}.xlsx`;

  saveAs(
    new Blob([buf], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    filename,
  );

  function styleHeader(cell, argb) {
    cell.alignment = center;
    cell.font = { bold: true };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb } };
    setBorder(cell);
  }

  function toNum(v) {
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  }

  function formatDateOnly(v) {
    if (!v) return "";
    const d = new Date(v);
    if (Number.isNaN(d.getTime())) return "";
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${dd}`;
  }

  function timestamp() {
    const now = new Date();
    return `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, "0")}${String(
      now.getDate(),
    ).padStart(2, "0")}-${String(now.getHours()).padStart(2, "0")}${String(
      now.getMinutes(),
    ).padStart(2, "0")}${String(now.getSeconds()).padStart(2, "0")}`;
  }

  function mapStatus(s) {
    const v = String(s || "").toLowerCase();
    if (v === "completed") return "Дууссан";
    if (v === "ongoing") return "Үргэлжилж буй";
    if (v === "upcoming") return "Тун удахгүй";
    if (v === "drawing") return "Сугалж байна";
    return s || "";
  }
}
